export default {
  properties: {
    OnClickAction: {
      name: 'vuetifyWidgets.drPropAction.action',
      type: 'object',
      component: 'dr-prop-action',
      properties: {
        Type: {
          name: 'vuetifyWidgets.drPropAction.type',
          type: 'string',
          enum: [
            {
              value: 'dataSourceAction',
              text: 'Data Source Action'
            },
            {
              value: 'OpenPage',
              text: 'vuetifyWidgets.drPropAction.openPage'
            },
            {
              value: 'RunMicroflow',
              text: 'vuetifyWidgets.drPropAction.runMicroFlow'
            },
            {
              value: 'RereadDataSource',
              text: 'vuetifyWidgets.drPropAction.rereadDataSource'
            },
            {
              value: 'RunJsAction',
              text: 'vuetifyWidgets.drPropAction.runJsAction'
            }
          ]
        },
        Page: {
          name: 'vuetifyWidgets.drPropAction.page',
          type: 'string',
          enum: []
        },
        MicroFlow: {
          name: 'vuetifyWidgets.drPropAction.codeMicroFlow',
          type: 'string',
          enum: []
        },
        Event: {
          name: 'vuetifyWidgets.drPropAction.eventMicroFlow',
          type: 'string'
        },
        Value: {
          name: 'vuetifyWidgets.drPropAction.value',
          type: 'string'
        },
        Parameters: {
          name: 'vuetifyWidgets.drPropAction.dictionaryParameter',
          type: 'string'
        },
        LoadIndicator: {
          name: 'vuetifyWidgets.drPropAction.loadIndicator',
          type: 'string',
          enum: [
            {
              value: 'noIndicator',
              text: 'vuetifyWidgets.drPropAction.noIndicator'
            },
            {
              value: 'nonBlockingUI',
              text: 'vuetifyWidgets.drPropAction.nonBlockingUI'
            },
            {
              value: 'blockingUI',
              text: 'vuetifyWidgets.drPropAction.blockingUI'
            }
          ]
        },
        LoadIndicatorText: {
          name: 'vuetifyWidgets.drPropAction.loadIndicatorText',
          type: 'string'
        },
        FieldsValidation: {
          name: 'vuetifyWidgets.drPropAction.fieldsValidation',
          type: 'boolean',
          default: false
        }
      }
    }
  }
}
  